/**
 * <s-form-embed> resizes a child JotForm iframe to its content height.
 * JotForm posts "setHeight:<px>:<formId>" messages from form.jotform.com.
 */
class SFormEmbed extends HTMLElement {
  #onMessage = (event) => {
    if (event.origin !== 'https://form.jotform.com' || typeof event.data !== 'string') return;
    const [action, value, formId] = event.data.split(':');
    if (action !== 'setHeight' || formId !== this.dataset.formId) return;
    const height = Number.parseInt(value, 10);
    const iframe = this.querySelector('iframe');
    if (iframe && height > 0) iframe.style.height = `${height}px`;
  };

  connectedCallback() {
    window.addEventListener('message', this.#onMessage);
  }

  disconnectedCallback() {
    window.removeEventListener('message', this.#onMessage);
  }
}

if (!customElements.get('s-form-embed')) customElements.define('s-form-embed', SFormEmbed);
